import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import Header from "@/layouts/Header/Header";

const PrivacyPolicy = () => {
  return (
    <>
    <Header />
    <Box
      sx={{
        position: "fixed",
        top: 64, // adjust based on your header height
        left: 0,
        right: 0,
        bottom: 0,
        overflowY: "auto",
        px: { xs: 2, sm: 4, md: 8 },
        py: 4,
        backgroundColor: "#fff",
      }}
    >
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        HBN Tech Privacy Policy
      </Typography>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Effective Date: June 5, 2025
      </Typography>

      <Divider sx={{ my: 2 }} />

      {[
        {
          title: "1. Introduction",
          content:
            'HBN Tech Pty Ltd ("we," "us," "our") operates an all-in-one real estate directory connecting home buyers with mortgage brokers, conveyancers, and building-pest inspectors. We are committed to protecting your privacy under the Privacy Act 1988 and the Australian Privacy Principles (APPs). This policy outlines how we collect, use, disclose, and secure your personal information, including sensitive financial data.',
        },
        {
          title: "2. Information We Collect",
          content: `We collect:\n\n- Personal Information: Name, email, phone number, postcode, and professional details (e.g., licence number) from mortgage brokers, conveyancers, and inspectors.\n- Sensitive Information: Payslips and tax documents from home buyers to facilitate broker interactions (only with explicit consent).\n- User Data: Home buyer inquiries (e.g., suburb, professional type sought).\n- Website Data: IP addresses, cookies, and usage analytics via tools like Google Analytics.\n\nWe only collect information necessary for our services and with your consent.`,
        },
        {
          title: "3. How We Use Your Information",
          content: `We use your data to:\n\n- Connect home buyers with professionals (e.g., sharing payslips with brokers for loan assessments).\n- Verify professionals’ credentials for compliance (e.g., ASIC standards).\n- Improve our platform through analytics.\n- Send updates or marketing (with opt-out options).\n\nWe do not provide financial advice or act as a credit provider.`,
        },
        {
          title: "4. Disclosure of Information",
          content: `We may disclose your information to:\n\n- Professionals you choose to connect with (e.g., brokers receiving payslips with your consent).\n- Service providers (e.g., hosting, analytics) under strict confidentiality agreements.\n- Legal authorities if required by law (e.g., under the Privacy Act or ASIC).\n\nWe do not sell your data to third parties.`,
        },
        {
          title: "5. Data Security",
          content:
            "We use encryption, secure servers, and access controls to protect your data, especially sensitive financial information like payslips and tax documents. We notify you of breaches per the Notifiable Data Breaches scheme. Report concerns to hello@hbn-tech.com.",
        },
        {
          title: "6. Access and Correction",
          content:
            "You can access, correct, or request deletion of your personal information, including payslips and tax documents, by emailing hello@hbn-tech.com. We respond within 30 days, per APP guidelines, and may charge a reasonable fee for excessive requests. Professionals can update profiles directly on our platform. If we deny access (e.g., legal reasons), we’ll explain why in writing.",
        },
        {
          title: "7. Cookies and Tracking",
          content:
            "We use cookies to enhance user experience and track website usage. You can disable cookies in your browser, but this may limit functionality. See our Cookie Policy on hbn-tech.com for details.",
        },
        {
          title: "8. Third-Party Links",
          content:
            "Our platform may link to external sites (e.g., professional profiles). We are not responsible for their privacy practices—review their policies separately.",
        },
        {
          title: "9. Complaints",
          content:
            "If you have privacy concerns, contact us at hello@hbn-tech.com. We aim to resolve issues within 30 days. If unsatisfied, you can escalate to the OAIC at oaic.gov.au.",
        },
        {
          title: "10. Changes to This Policy",
          content:
            "We may update this policy as our services evolve. Changes will be posted on hbn-tech.com with the updated effective date. Check regularly for updates.",
        },
        {
          title: "11. Contact Us",
          content:
            "For questions, contact:\nHBN Tech Pty Ltd\nEmail: hello@hbn-tech.com\nWebsite: https://hbn-tech.com \nWe’re committed to safeguarding your privacy while connecting you with trusted professionals.",
        },
          ].map((section, index) => (
          <Box key={index} mb={3}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              {section.title}
            </Typography>
            {section.content.split("\n").map((line, i) => {
              if (line.startsWith("Website:")) {
                const url = line.replace("Website:", "").trim();
                const fullUrl = url.startsWith("http") ? url : `https://${url}`;
                return (
                  <Typography variant="body2" paragraph key={i}>
                    Website: <a href={fullUrl} target="_blank" rel="noopener noreferrer">{url}</a>
                  </Typography>
                );
              }
              else if (line.startsWith("Email:")) {
                const email = line.replace("Email:", "").trim();
                return (
                  <Typography variant="body2" paragraph key={i}>
                    Email: <a href={`mailto:${email}`}>{email}</a>
                  </Typography>
                );
              }
              else {
                return (
                  <Typography variant="body2" paragraph key={i}>
                    {line}
                  </Typography>
                );
              }
            })}
          </Box>
        ))}
        
    </Box>
    </>
  );
};

export default PrivacyPolicy;
